import axios from 'axios.js'

export const GET_WORKER_MEASUREMENTS = 'GET_WORKER_MEASUREMENTS'
export const ADD_WORKER_MEASUREMENT = 'ADD_WORKER_MEASUREMENT'
export const UPLOAD_WORKER_MEASUREMENTS = 'UPLOAD_WORKER_MEASUREMENTS'
export const GET_WORKER_MEASUREMENTS_STATS = 'GET_WORKER_MEASUREMENTS_STATS'

const GET_WORKER_MEASUREMENT_PATH = {
    api: {
        worker: {
            measurements: {
                _queries: {
                    page: {},
                    size: {},
                    sort: {}
                },
                stats:{
                    _queries:{
                        subject:{}
                    }
                },
                upload:{
                    _queries:{
                        shift:{},
                        date:{}
                    }

                }
            }
        }
    }
}

const GET_WORKER_MEASUREMENTS_URL = '/api/worker/measurements'
const GET_WORKER_MEASUREMENTS_STATS_URL = '/api/worker/measurements/stats'
const UPLOAD_WORKER_MEASUREMENTS_URL = '/api/worker/measurements/upload/'

export const getMeasurements = (filter, paginate) => (dispatch) => {
    if (filter !== null && paginate !== null) {
        console.log("Get All User called")
        axios.post(GET_WORKER_MEASUREMENTS_URL, filter, {params: paginate}).then((res) => {
            if (res.data.result_status === 200) {
                dispatch({
                    type: GET_WORKER_MEASUREMENTS,
                    payload: res.data.data,
                })
            } else {
                dispatch({
                    type: GET_WORKER_MEASUREMENTS,
                    payload: null,
                })
            }
        })
    }
}

export const getMeasurementsStats = (subject, filter) => (dispatch) => {
    if (subject !== null && filter !== null) {
        console.log("Get All User called")
        axios.post(GET_WORKER_MEASUREMENTS_STATS_URL, filter, {params: {"subject":subject}}).then((res) => {
            if (res.data.result_status === 200) {
                let data = []
                data[res.data.data.name] = res.data.data.values
                dispatch({
                    type: GET_WORKER_MEASUREMENTS_STATS,
                    payload: data,
                })
            }
        })
    }
}

export const uploadMeasurementsData = (shift, date, file) => (dispatch) => {
    if (shift !== null && date !== null && file != null) {
        let formData = new FormData()
        //let imagefile = document.querySelector('#file');
        //formData.append("image", imagefile.files[0])
        formData.append("file", file)
        axios.post(UPLOAD_WORKER_MEASUREMENTS_URL, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },params:{
                "shift":shift,
                "date":date
            }
        }).then((res) => {
            dispatch({
                type: UPLOAD_WORKER_MEASUREMENTS,
                payload: res.data,
            })
        })
    }
}



